import { Close, Refresh } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { isPhoneOrHighScreen } from '@/utilities/sizeUtils';
import { TargetNameAndDescription } from './TargetNameAndDescription';

export function HeaderNameAndIcons({
  name,
  description,
  onReload,
  onClose,
}: {
  name: string;
  description?: string;
  onReload?: () => void;
  onClose: () => void;
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
      <TargetNameAndDescription
        targetName={name}
        targetDescription={description}
        styleClassName={`target-name-and-description-bottom-sheet ${isPhoneOrHighScreen() ? 'route-name-text' : ''}`}
      />
      <span>
        {onReload !== undefined && (
          <IconButton
            color="primary"
            onClick={onReload}
            sx={{ alignSelf: 'start' }}
            data-qa-element-id="popup_refresh_button"
          >
            <Refresh />
          </IconButton>
        )}
        <IconButton
          color="primary"
          onClick={onClose}
          sx={{ alignSelf: 'start' }}
          data-qa-element-id="popup_close_button"
        >
          <Close />
        </IconButton>
      </span>
    </div>
  );
}
